import React, { useContext } from 'react';
import styled from 'styled-components';
import { Section } from '../../styled-components';
import context from '../../context';

/* título centrado */
const Title = styled.h4`
  color: #111;
  text-align: center;
  margin: 0 0 .75rem;
  font-weight: 900;
`;

/* contenedor full-bleed con padding lateral */
const FullBleed = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  /* padding lateral moderado */
  --side-pad: clamp(1.5rem, 8vw, 6rem);
  padding-left: var(--side-pad);
  padding-right: var(--side-pad);
`;

/* grilla de logos */
const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  justify-items: center;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ClientLogo = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  max-width: clamp(120px, 14vw, 200px);
`;

export default function Asosiaciones() {
  const state = useContext(context);
  const clientsLogos = state?.home?.clientLogos || [];

  return (
    <Section>
      <FullBleed>
        <br />
        <Title>Las Flores Inmobiliaria</Title>
        <br />
        <ClientsGrid>
          {clientsLogos.map((src, i) => (
            <ClientLogo key={i} src={src} alt={`Logo ${i + 1}`} />
          ))}
        </ClientsGrid>
        <br />
      </FullBleed>
    </Section>
  );
}